import { API_END_POINTS } from "../../constant/config";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_SMTP_DETAILS} from "../type";

// Get SMTP details
export const fetchSmtpDetails = () => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.SMTP_DETAILS_GET;
        console.log(apiEndpoint)
        const response = await JsonInterceptor.get(`${apiEndpoint}`)
        dispatch({
            type: GET_SMTP_DETAILS,
            payload: response.data.data[0],
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Update SMTP Details
export const updateSmtpDetails = (data, id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.SMTP_DETAILS_UPDATE;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`, data)
        dispatch({
            type: GET_SMTP_DETAILS,
            payload: response.data.data,
        });
        return response.data;
    } catch (error) {
        if (error.response) {
             dispatch({
                type: GET_SMTP_DETAILS,
                payload: error.response.data,
            });

            return error.response.data;
        }
    }
};